import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { useSidebar } from "@/contexts/SidebarContext";

const DrawerContext = createContext<{
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  drawerWidth: number;
  setDrawerWidth: (width: number) => void;
}>(
  {} as {
    isOpen: boolean;
    openDrawer: () => void;
    closeDrawer: () => void;
    drawerWidth: number;
    setDrawerWidth: (width: number) => void;
  },
);

interface DrawerProviderProps {
  children: React.ReactNode;
}

export const DrawerProvider = ({ children }: DrawerProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { setCollapsed } = useSidebar();
  const [drawerWidth, setDrawerWidth] = useState(window.innerWidth * 0.5);

  const openDrawer = useCallback(() => {
    setCollapsed(true);
    setIsOpen(true);
  }, [setCollapsed]);

  const closeDrawer = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, openDrawer, closeDrawer, drawerWidth, setDrawerWidth }),
    [isOpen, openDrawer, closeDrawer, drawerWidth],
  );

  return (
    <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>
  );
};

export const useDrawer = () => useContext(DrawerContext);
